export default __webpack_public_path__ + "static/media/towering.cb33c73f.jpg";